import request from '../request';

export function getManagerWaterRound(params) {
  return request({
    url: "/manager/water-rounds",
    method: "get",
    params
  })
}

export function showManagerWaterRound(id) {
  return request({
    url: `/manager/water-rounds/${id}`,
    method: "get"
  })
}

export function storeManagerWaterRound(data) {
  return request({
    url: "/manager/water-rounds",
    method: "post",
    data
  })
}

export function finishManagerWaterRound(data) {
  return request({
    url: `/manager/water-rounds/${data.id}/finish`,
    method: "post",
    data
  })
}

export function updateManagerWaterRound(data) {
  return request({
    url: `/manager/water-rounds/${data.id}`,
    method: "put",
    data
  })
}

export function deleteManagerWaterRound(id) {
  return request({
    url: `/manager/water-rounds/${id}`,
    method: "delete"
  })
}

export function checkIfDriverHasOpenRound(id) {
  return request({
    url: `/manager/check-driver-has-open-round/${id}`,
    method: 'get'
  })
}
